import { render, staticRenderFns } from "./invoicing.vue?vue&type=template&id=58c2a77e"
import script from "./invoicing.vue?vue&type=script&lang=js"
export * from "./invoicing.vue?vue&type=script&lang=js"
import style0 from "./invoicing.vue?vue&type=style&index=0&id=58c2a77e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports